<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="paddingContent">
      <div class="contentbox" v-if="this.$route.query.status == 'problem'">
        <div class="box-card">
          <div class="cardHeader">
            <div class="cardHeaderLeft">問題描述</div>
          </div>
          <div class="cardBody">
            <div class="cardRow">
              <div class="cardRowLeft">問題類型：</div>
              <div class="cardRowRight">
                {{ questionKind ? questionKind : "-" }}
              </div>
            </div>
            <div class="cardRow" style="margin-top: 20px">
              <div class="cardRowLeft">問題描述：</div>
              <div class="cardRowRight">
                {{ questionDescription ? questionDescription : "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contentbox">
        <div class="contentLeft">
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">訂單資訊</div>
              <div class="cardHeaderRight">
                <el-select
                  v-if="this.$route.query.status != 'problem'"
                  v-model="orderStatus"
                  placeholder="請選擇訂單狀態"
                  size="small"
                  @change="orderStatusChange"
                >
                  <el-option label="待付款" value="1"></el-option>
                  <el-option label="已付款" value="2"></el-option>
                  <el-option label="待審核" value="7"></el-option>
                  <el-option label="付款失敗" value="3"></el-option>
                  <el-option label="訂單取消" value="8"></el-option>
                  <el-option label="待出貨" value="11"></el-option>
                  <el-option label="已出貨" value="5"></el-option>
                  <el-option label="訂單完成" value="6"></el-option>
                  <el-option label="退件" value="10"></el-option>
                </el-select>
              </div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in orderInfoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div
                  class="cardRowRight_status"
                  v-if="item.key === 'orderStatus'"
                >
                  {{ orderInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else-if="orderInfo[item.key]">
                  {{ orderInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">訂單人資訊</div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in orderPersonLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="memberDto[item.key]">
                  {{ memberDto[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">付款資訊</div>
            </div>
            <div class="cardBody" v-if="payFlowDto.paymentDocument">
              <div
                class="cardRow"
                v-for="(item, index) in payFlowDtoLabelBank"
                :key="item.key"
                :style="{
                  marginTop: index === 0 ? '0px' : '20px',
                  alignItems: 'flex-start',
                }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div
                  class="cardRowRight allpointer"
                  v-if="item.key === 'paymentDocument'"
                  style="position: relative"
                  @mouseover="bigimghover = true"
                  @mouseout="bigimghover = false"
                >
                  <img
                    :src="payFlowDto[item.key]"
                    class="voucherBlock"
                    v-viewer="{ movable: false }"
                    style="
                      width: 80px;
                      height: 80px;
                      border-radius: 4px;
                      object-fit: cover;
                    "
                  />
                  <div class="coverbig" v-show="bigimghover" @click="lookbig">
                    <div>
                      <img
                        src="@/assets/images/common/look_big_up.png"
                        style="width: 16px; height: 16px; marginleft: 20px"
                      />
                      <div>
                        <img
                          src="@/assets/images/common/look_big.png"
                          style="width: 56px; height: 20px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cardRowRight" v-else-if="payFlowDto[item.key]">
                  {{ payFlowDto[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
            <div class="cardBody" v-else>
              <div
                class="cardRow"
                v-for="(item, index) in payFlowDtoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="payFlowDto[item.key]">
                  {{ payFlowDto[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
        </div>
        <div class="contentRight">
          <div class="box-card" v-if="this.orderInfo.orderType != '活動'">
            <div class="cardHeader">
              <div class="cardHeaderLeft">收件人資訊</div>
              <div
                class="cardHeaderRight_edit"
                @click="showEdit()"
                v-if="this.$route.query.status != 'problem'"
              >
                編輯
              </div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in receiverLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="receiverInfo[item.key]">
                  {{ receiverInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">商品詳情</div>
              <div
                class="cardHeaderRight_edit"
                @click="showEditshop()"
                v-if="
                  this.$route.query.status == 'out' &&
                  (orderInfo.orderStatus === '待出貨' ||
                    orderInfo.orderStatus === '已付款')
                "
              >
                編輯
              </div>
            </div>
            <div class="cardBody">
              <div
                class="shoplist"
                v-for="(item, index) in orderDetailDto"
                :key="item.id"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="shoplist_top">{{ item.goodsName }}</div>
                <div class="shoplist_bottom">
                  <div class="shoplist_detail" v-if="item.goodsType != 2">
                    {{ item.goodsDetail }}
                  </div>
                  <div class="shoplist_detail" v-else></div>
                  <div style="display: flex; align-items: center">
                    <div class="shoplist_num">×{{ item.goodsAmount }}</div>
                    <div style="margin-left: 20px">
                      <div class="shoplist_price">
                        {{ item.goodsRecievablePrice }}{{ currency }}
                        <div
                          class="priceLine"
                          v-if="
                            item.goodsReceiptsPrice !==
                            item.goodsRecievablePrice
                          "
                        ></div>
                      </div>
                      <div
                        style="font-size: 14px; color: #7d54ec"
                        v-if="
                          item.goodsReceiptsPrice !== item.goodsRecievablePrice
                        "
                      >
                        {{ item.goodsReceiptsPrice }}{{ currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="shop_row">
                <div class="texttypelow">小計</div>
                <div class="texttypelow" v-if="discountRecievablePrice">
                  {{ discountRecievablePrice }}{{ currency }}
                </div>
                <div class="texttypelow" v-else>
                  {{ recievablePrice }}{{ currency }}
                </div>
              </div>
              <div class="shop_row">
                <div class="texttypelow">運費</div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                  "
                >
                  <div class="texttypelow" style="position: relative">
                    {{ extraPrice }}{{ currency }}
                    <div v-if="discountExtraPrice" class="priceLine"></div>
                  </div>
                  <div
                    style="color: #7d54ec; font-size: 14px"
                    v-if="discountExtraPrice"
                  >
                    {{ discountExtraPrice }}{{ currency }}
                  </div>
                </div>
              </div>
              <div class="shop_row">
                <div class="texttypedeep">總金額</div>
                <div class="texttypedeep">
                  {{ receiptsPrice }}{{ currency }}
                </div>
              </div>
            </div>
          </div>
          <div class="remark_box">
            <div class="remark_box_input">
              <div class="remark_box_text">版工備註：</div>
              <el-input
                type="textarea"
                style="flex: 1"
                :rows="3"
                placeholder="请输入版工備註"
                v-model="remark"
                maxlength="100"
              >
              </el-input>
            </div>
            <div class="remark_box_button">
              <div
                class="btn borderBtn"
                @click="reset()"
                style="margin-right: 30px"
              >
                清空重置
              </div>
              <div class="btn" @click="handleSave()">確認保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="收件人資訊"
      :visible.sync="editmodal"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog modalform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div style="marginright: 110px">
            <el-form-item
              label="物流公司"
              prop="trackingCompany"
              class="formpadding"
            >
              <el-input
                v-model="ruleForm.trackingCompany"
                placeholder="请输入物流公司"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="貨運單號"
              prop="trackingNumber"
              class="formpadding"
            >
              <el-input
                v-model="ruleForm.trackingNumber"
                placeholder="请输入貨運單號"
              ></el-input>
            </el-form-item>
            <el-form-item label="收件人" prop="receiver">
              <el-input
                v-model="ruleForm.receiver"
                placeholder="请输入收件人"
              ></el-input>
            </el-form-item>
            <el-form-item label="手機號碼" prop="receivePhone">
              <el-input
                v-model="ruleForm.receivePhone"
                placeholder="请输入手機號碼"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="郵政區號"
              prop="receiveCode"
              class="formpadding"
            >
              <el-input
                v-model="ruleForm.receiveCode"
                placeholder="请输入郵政區號"
              ></el-input>
            </el-form-item>
          </div>
          <div class="threeinline">
            <el-form-item label="收件地址" prop="country">
              <el-input
                v-model="ruleForm.country"
                placeholder="请输入省"
              ></el-input>
            </el-form-item>
            <el-form-item prop="city">
              <el-input
                v-model="ruleForm.city"
                placeholder="请输入市"
              ></el-input>
            </el-form-item>
            <el-form-item prop="region">
              <el-input
                v-model="ruleForm.region"
                placeholder="请输入区"
              ></el-input>
            </el-form-item>
          </div>
          <div class="addressdetail">
            <el-form-item prop="receiverAddress">
              <el-input
                v-model="ruleForm.receiverAddress"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          class="btn borderBtn"
          style="marginright: 32px"
          @click="resetDefault"
        >
          恢復默認
        </div>
        <div class="btn" @click="submitForm('ruleForm')">修改</div>
      </span>
    </el-dialog>

    <el-dialog
      title="編輯商品詳情"
      :visible.sync="editshopmodal"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog modalform">
        <div
          class="shoplist"
          v-for="(item, index) in orderDetailDtoIn"
          :key="item.id"
          :style="{ marginTop: index === 0 ? '0px' : '25px' }"
        >
          <div class="shoprow">
            <div class="shoplist_topin">
              {{ item.goodsName }}
            </div>
            <el-popover
              v-model="item.displaydelete"
              placement="left-start"
              width="260"
            >
              <div class="rowdelete">
                <img
                  src="@/assets/images/common/warning_purple.png"
                  style="width: 20px; height: 18px"
                />
                <div class="rowdeleteTitle">刪除商品</div>
              </div>
              <div class="line"></div>
              <div style="fontsize: 12px; color: rgba(41, 41, 41, 0.8)">
                確定要刪除該商品嗎？
              </div>
              <div
                style="text-align: right; margintop: 16px; marginbottom: 6px"
              >
                <el-button
                  size="mini"
                  type="text"
                  @click="item.displaydelete = false"
                  style="background: #938ea4; color: #fff"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="deleteOrderDetailDtoIn(item.id)"
                  >确定</el-button
                >
              </div>
              <img
                slot="reference"
                v-if="
                  !(
                    item.goodsType == 1 ||
                    item.goodsType == 2 ||
                    item.goodsType == 4
                  ) && orderDetailDtoIn.length > 1
                "
                src="@/assets/images/common/order_delete_icon.png"
                alt=""
                :style="{ width: '14.2px', height: '14.2px' }"
              />
            </el-popover>
          </div>
          <div class="shoprow" style="margin-top: 22px">
            <div class="shopdetail">
              <div
                class="type"
                v-if="item.goodsDetail"
                style="marginright: 45px"
              >
                <span> SKU： </span>
                <el-input
                  v-model="item.shopright"
                  v-if="!item.goodsSkuList.length"
                  :disabled="
                    item.goodsType == 1 ||
                    item.goodsType == 2 ||
                    item.goodsType == 4
                  "
                ></el-input>
                <el-select
                  v-model="item.shopSkuId"
                  @change="changeShopRight(item)"
                  v-else
                >
                  <el-option
                    v-for="ite in item.goodsSkuList"
                    :key="ite.goodsSkuId"
                    :label="ite.attrValue"
                    :value="ite.goodsSkuId"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="amount" style="margin-left: 10px">
                <span> 数量： </span>
                <el-input
                  v-model="item.goodsAmount"
                  type="number"
                  @input="handleInput($event, index)"
                  :disabled="
                    item.goodsType == 1 ||
                    item.goodsType == 2 ||
                    item.goodsType == 4
                  "
                ></el-input>
              </div>
            </div>
            <div>
              <div class="shopprice" style="color: #878399">
                {{ item.goodsRecievablePrice }}{{ currency }}
                <div
                  class="priceLine"
                  v-if="item.goodsReceiptsPrice !== item.goodsRecievablePrice"
                ></div>
              </div>
              <div
                class="shopprice"
                v-if="item.goodsReceiptsPrice !== item.goodsRecievablePrice"
              >
                {{ item.goodsReceiptsPrice }}{{ currency }}
              </div>
            </div>
          </div>

          <div class="linee" v-if="index + 1 != orderDetailDtoIn.length"></div>
        </div>
        <div class="shopinback">
          <div class="shop_row" style="margin-top: 0px">
            <div class="typeinlow">小計</div>
            <div class="texttypelow" v-if="discountRecievablePrice">
              {{ discountRecievablePrice }}{{ currency }}
            </div>
            <div class="texttypelow" v-else>
              {{ recievablePrice }}{{ currency }}
            </div>
          </div>
          <div class="shop_row">
            <div class="typeinlow">運費</div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-end;
              "
            >
              <div class="texttypelow">
                {{ extraPrice }}{{ currency }}
                <div v-if="discountExtraPrice" class="priceLine"></div>
              </div>
              <div
                style="color: #7d54ec; font-size: 14px"
                v-if="discountExtraPrice"
              >
                {{ discountExtraPrice }}{{ currency }}
              </div>
            </div>
          </div>
          <div class="shop_row">
            <div class="texttypedeep">總金額</div>
            <div class="texttypedeep" style="color: #6c3dea; fontweight: 500">
              {{ receiptsPrice }}{{ currency }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          class="btn borderBtn"
          style="margin-right: 30px"
          @click="resetDefaultshop"
        >
          恢復默認
        </div>
        <div class="btn" @click="handlePermiss">修改</div>
      </span>
    </el-dialog>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock:
        this.$route.query.status == "all"
          ? "訂單  /  所有訂單"
          : this.$route.query.status == "out"
          ? "訂單  /  出貨訂單"
          : "訂單  /  問題訂單",
      navtitle: "查看詳情",
      bigimghover: true,
      orderNum: this.$route.query.orderNum,
      dialogVisible: false,
      orderStatus: "", //需要传值的orderStatus
      orderInfo: {},
      memberDto: {},
      payFlowDto: {},
      receiverInfo: {},
      orderDetailDto: [],
      currency: "",
      recievablePrice: "", //小计
      discountRecievablePrice: "", //折扣后小计
      extraPrice: "", //运费
      discountExtraPrice: "",
      receiptsPrice: "", //总价
      remark: "", //备注
      editmodal: false, //编辑弹窗
      editshopmodal: false, //商品信息弹窗
      ruleForm: {
        trackingCompany: "",
        trackingNumber: "",
        receiver: "",
        receivePhone: "",
        receiveCode: "",
        country: "",
        city: "",
        region: "",
        receiverAddress: "",
      },
      orderDetailDtoIn: [], //商品信息弹窗里的内容
      deleteDetailId: [], //商品详情删除需要传的id
      address: "",
      submitreceiverData: {},
      rules: {
        // trackingCompany:[
        //   { required: true, message: '请输入物流公司', trigger: 'change' },
        // ],
        // trackingNumber:[
        //   { required: true, message: '请输入貨運單號', trigger: 'change' },
        // ],
        receiver: [
          { required: true, message: "请输入收件人", trigger: "change" },
        ],
        receivePhone: [
          { required: true, message: "请输入手機號碼", trigger: "change" },
        ],
        // areaCode:[
        //   { required: true, message: '请输入郵政區號', trigger: 'change' },
        // ],
        country: [{ required: true, message: "请输入省", trigger: "change" }],
        city: [{ required: true, message: "请输入市", trigger: "change" }],
        // region:[
        //   { required: true, message: '请输入区', trigger: 'change' },
        // ],
        receiverAddress: [
          { required: true, message: "请输入详细地址", trigger: "change" },
        ],
      },
      receiverLabel: [
        {
          label: "物流公司：",
          key: "trackingCompany",
        },
        {
          label: "貨運單號：",
          key: "trackingNumber",
        },
        {
          label: "收件人：",
          key: "receiver",
        },
        {
          label: "手機號碼：",
          key: "receivePhone",
        },
        {
          label: "郵政區號：",
          key: "receiveCode",
        },
        {
          label: "收件地址：",
          key: "receiverAddress",
        },
      ],
      payFlowDtoLabel: [
        {
          label: "付款日期：",
          key: "payTime",
        },
        {
          label: "付款方式：",
          key: "payMethod",
        },
        {
          label: "流水編號：",
          key: "payFlowId",
        },
        {
          label: "平台交易編號：",
          key: "oidPartner",
        },
      ],
      payFlowDtoLabelBank: [
        {
          label: "付款日期：",
          key: "payTime",
        },
        {
          label: "付款方式：",
          key: "payMethod",
        },
        {
          label: "轉賬單據：",
          key: "paymentDocument",
        },
      ],
      orderPersonLabel: [
        {
          label: "會員編號：",
          key: "id",
        },
        {
          label: "用戶帳號：",
          key: "email",
        },
        {
          label: "真實姓名：",
          key: "realname",
        },
        {
          label: "會籍結束時間：",
          key: "endTime",
        },
        {
          label: "手機號碼：",
          key: "mobile",
        },
        {
          label: "會員地址：",
          key: "address",
        },
      ],
      orderInfoLabel: [
        {
          label: "訂單編號：",
          key: "orderNum",
        },
        {
          label: "創建時間：",
          key: "createTime",
        },
        {
          label: "訂單狀態：",
          key: "orderStatus",
        },
        {
          label: "訂單類型：",
          key: "orderType",
        },
        {
          label: "訂單會籍生效時間：",
          key: "vipStartTime",
        },
        {
          label: "訂單會籍結束時間：",
          key: "vipEndTime",
        },
      ],
      questionKind: "",
      questionDescription: "",
    };
  },
  computed: {
    calculateRecievablePrice() {
      let result = 0;
      this.orderDetailDtoIn.map((item) => {
        result =
          result + Number(item.goodsAmount) * Number(item.goodsRecievablePrice);
      });
      return result;
    },
    calculategoodsReceiptsPrice() {
      return this.calculateRecievablePrice + Number(this.extraPrice);
    },
  },
  created() {
    let _this = this;
    _this.getOrderDetails();
  },
  destroyed() {
    this.$bus.$emit("refreshall");
    this.$bus.$emit("refreshout");
    this.$message.closeAll();
  },
  methods: {
    getOrderDetails() {
      let _this = this;
      _this
        .$get(
          `request/order/v2/getOrderDetail?orderNum=${_this.orderNum}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            this.orderInfo = {
              orderNum: this.$route.query.orderNum,
              orderStatus: res.data.orderStatus,
              createTime: res.data.createTime,
              orderType: res.data.orderType,
              vipStartTime: res.data.vipStartTime,
              vipEndTime: res.data.vipEndTime,
            };
            this.receiverInfo = {
              trackingCompany: res.data.trackingCompany,
              trackingNumber: res.data.trackingNumber,
              receiver: res.data.receiver,
              receivePhone: res.data.receivePhone,
              receiveCode: res.data.receiveCode,
              receiverAddress: res.data.receiverAddress,
              country: res.data.country,
              city: res.data.city,
              region: res.data.region,
            };
            this.address = res.data.address;
            this.memberDto = res.data.memberDto;
            this.orderDetailDto = res.data.orderDetailDto;
            this.currency = res.data.currency;
            this.recievablePrice = res.data.recievablePrice;
            this.discountRecievablePrice = res.data.discountRecievablePrice;
            this.extraPrice = res.data.extraPrice;
            this.discountExtraPrice = res.data.discountExtraPrice;
            this.receiptsPrice = res.data.receiptsPrice;
            this.remark = res.data.remark;
            this.questionDescription = res.data.questionDescription;
            this.questionKind = res.data.questionKind;
            if (res.data.payFlowDto) this.payFlowDto = res.data.payFlowDto;
            this.orderDetailDto.map((item) => {
              if (item.goodsDetail) {
                let result = item.goodsDetail;
                if (result.includes(":")) {
                  result = result.replace(/\s/g, "");
                  item.shopleft = result.split(":")[0];
                  item.shopright = result.split(":")[1];
                  if (item.goodsSkuList.length) {
                    item.goodsSkuList.map((ite) => {
                      if (ite.attrValue == item.shopright)
                        item.shopSkuId = ite.goodsSkuId;
                    });
                  }
                } else {
                  item.shopright = result;
                }
              }
            });
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    handleInput(event, index) {
      const inputValue = parseInt(event, 10); // 解析为整数
      if (inputValue > 9) {
        this.orderDetailDtoIn[index].goodsAmount = 9;
      } else if (inputValue <= 1) {
        this.orderDetailDtoIn[index].goodsAmount = 1; // 默认为1或其他处理方式
      } else if (!isNaN(inputValue)) {
        this.orderDetailDtoIn[index].goodsAmount = inputValue;
      }
    },
    //重置备注
    reset() {
      this.remark = "";
    },
    //收件人恢复默认
    resetDefault() {
      let current = JSON.parse(JSON.stringify(this.receiverInfo));
      current.receiverAddress = this.address;
      this.ruleForm = current;
    },
    //商品详情恢复默认
    resetDefaultshop() {
      let current = JSON.parse(JSON.stringify(this.orderDetailDto));
      this.orderDetailDtoIn = current;
      this.deleteDetailId = [];
    },
    //确认保存
    handleSave() {
      this.handleChangeOrder("save");
    },
    //编辑弹窗
    showEdit() {
      this.resetDefault();
      this.editmodal = true;
    },
    showEditshop() {
      this.resetDefaultshop();
      console.log(this.orderDetailDtoIn);

      this.editshopmodal = true;
    },
    //编辑页面修改
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitreceiverData = JSON.parse(JSON.stringify(this.ruleForm));
          this.handleChangeOrder("save", "edit");
        } else {
          return false;
        }
      });
    },
    //查看大图
    lookbig() {
      let _this = this;
      const viewer = _this.$el.querySelector(".voucherBlock").$viewer;
      viewer.show();
    },
    //订单状态
    orderStatusChange() {
      this.handleChangeOrder("", "changestatus");
    },
    //校验
    handlePermiss() {
      let _this = this;
      let flag = true;
      _this.orderDetailDtoIn.map((item) => {
        if (item.goodsDetail) {
          if (item.shopright === "") {
            _this.dialogVisible = true;
            flag = false;
            _this.$propMessage("sku不能為空", "error", function () {
              _this.dialogVisible = false;
            });
          }
        }
      });
      flag && _this.handleChangeOrder("save", "editshop");
    },
    //修改订单方法
    handleChangeOrder(type, typeedit) {
      let _this = this;
      let param = {
        orderNum: this.$route.query.orderNum,
        remark: this.remark,
      };
      if (typeedit === "changestatus") {
        param = { ...param, orderStatus: this.orderStatus };
      } else if (typeedit === "edit") {
        param = {
          ...param,
          trackingCompany: this.submitreceiverData.trackingCompany,
          trackingNumber: this.submitreceiverData.trackingNumber,
          receiver: this.submitreceiverData.receiver,
          receivePhone: this.submitreceiverData.receivePhone,
          receiveCode: this.submitreceiverData.receiveCode,
          country: this.submitreceiverData.country,
          city: this.submitreceiverData.city,
          region: this.submitreceiverData.region,
          address: this.submitreceiverData.receiverAddress,
        };
      } else if (typeedit === "editshop") {
        let orderDetailRequest = [];
        this.orderDetailDtoIn.map((item) => {
          if (item.goodsDetail) {
            let current = {
              id: item.id,
              num: item.goodsAmount,
              goodsDetail: item.shopleft
                ? item.shopleft + ": " + item.shopright
                : item.shopright,
            };
            if (item.goodsSkuList.length) {
              if (item.shopSkuId) {
                current = {
                  ...current,
                  skuId: item.shopSkuId,
                };
              }
            }
            orderDetailRequest.push(current);
          } else {
            orderDetailRequest.push({
              id: item.id,
              num: item.goodsAmount,
            });
          }
        });
        param = {
          ...param,
          orderDetailRequest,
          deleteDetailId: this.deleteDetailId,
        };
      }
      _this
        .$post("/request/order/v2/editOrder", param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === "00000") {
            _this.dialogVisible = true;
            _this.$propMessage(
              type === "save" ? "更改訂單詳情成功" : "更改訂單狀態成功",
              "success",
              function () {
                _this.dialogVisible = false;
              }
            );
            _this.editmodal = false;
            _this.editshopmodal = false;
            _this.getOrderDetails();
          } else {
            if (type !== "save") {
              this.orderStatus = undefined;
            }
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    deleteOrderDetailDtoIn(id) {
      this.deleteDetailId.push(id);
      const current = this.orderDetailDtoIn.filter((item) => item.id !== id);
      this.orderDetailDtoIn.splice(0, this.orderDetailDtoIn.length, ...current);
      console.log("this.orderDetailDto", this.orderDetailDtoIn);
    },
    changeShopRight(item) {
      item.goodsSkuList.map((ite) => {
        if (ite.goodsSkuId == item.shopSkuId) {
          item.shopright = ite.attrValue;
        }
      });
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>

<style lang="less" scoped>
.rowdelete {
  display: flex;
  align-items: center;
  .rowdeleteTitle {
    color: rgba(41, 41, 41, 1);
    font-size: 14px;
    font-weight: 500;
    margin-left: 8px;
  }
}
.line {
  height: 0.5px;
  background: rgba(238, 238, 238, 1);
  width: 100%;
  margin-top: 9px;
  margin-bottom: 9px;
}
.el-button--mini {
  padding: 5px 9px;
}
.contentDetails {
  .paddingContent {
    width: 100%;
    overflow: auto;
    background: none;
  }
  .box-card {
    width: 100%;
    min-width: 300px;
    background: #fafafd;
    border-radius: 12px;
    margin-bottom: 44px;
    .cardHeader {
      height: 68px;
      background: #f2f2f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 3px solid #e5e4ea;
      padding: 20px;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      .cardHeaderLeft {
        font-size: 0.16rem;
        color: #6c3dea;
      }
      .cardHeaderRight_edit {
        padding: 5px 16px;
        border: 1px solid #6c3dea;
        border-radius: 4px;
        color: #6c3dea;
        cursor: pointer;
      }
    }
    .cardBody {
      padding: 20px;
      .cardRow {
        display: flex;
        .cardRowLeft {
          color: #938ea4;
          font-size: 0.14rem;
          text-align: left;
          width: 140px;
          flex-shrink: 0;
        }
        .allpointer {
          div {
            cursor: pointer !important;
          }
        }
        .cardRowRight {
          color: #292929;
          font-size: 0.14rem;
          text-align: left;
          word-break: break-all;
        }
        .cardRowRight_status {
          padding: 4px 8px;
          background: #6c3dea;
          color: #ffffff;
          font-size: 0.14rem;
          border-radius: 4px;
        }
        .coverbig {
          width: 80px;
          height: 80px;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 4px;
          background: rgba(41, 41, 41, 1);
          opacity: 0.6;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .shoplist {
    .shoplist_top {
      text-align: left;
      color: #292929;
      font-size: 0.14rem;
    }
    .shoplist_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .shoplist_detail {
        color: #292929;
        opacity: 0.6;
        font-size: 0.12rem;
      }
      .shoplist_num {
        color: #938ea4;
        font-size: 0.14rem;
        margin-right: 10px;
      }
      .shoplist_price {
        color: #878399;
        font-size: 0.14rem;
        text-align: right;
        position: relative;
      }
    }
    .shoprow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .shoplist_topin {
        font-size: 0.14rem;
        color: #121212;
        font-weight: 500;
      }
      .shopdetail {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        flex-shrink: 0;
        span {
          font-size: 0.14rem;
          color: #292929;
          opacity: 0.6;
        }
      }
    }
    .shopprice {
      color: #7d54ec;
      font-size: 0.14rem;
      text-align: right;
      font-weight: 500;
      position: relative;
    }
  }
  .shopinback {
    background: #f5f5fc;
    border-radius: 4px;
    padding: 23px 12px 23px 12px;
    margin-top: 27px;
  }
  .line {
    height: 0.5px;
    background: #d9d7e0;
    width: 100%;
    margin-top: 32px;
  }
  .linee {
    height: 0.5px;
    background: #eeeeee;
    width: 100%;
    margin-top: 25px;
  }
  .shop_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .texttypelow {
      color: #292929;
      opacity: 0.6;
      font-size: 0.14rem;
      position: relative;
    }
    .typeinlow {
      color: #938ea4;
      font-size: 0.14rem;
    }
    .texttypemiddle {
      color: #292929;
      opacity: 0.6;
      font-size: 0.14rem;
    }
    .texttypedeep {
      color: #292929;
      opacity: 1;
      font-size: 0.14rem;
    }
  }
  .remark_box {
    width: 100%;
    min-width: 300px;
    background: #fafafd;
    border-radius: 12px;
    margin-bottom: 44px;
    padding: 20px;
    .remark_box_button {
      display: flex;
      justify-content: flex-end;
      margin-top: 32px;
    }
    .remark_box_input {
      display: flex;
    }
    /deep/ .el-textarea__inner {
      height: 100px;
      line-height: 20px;
      width: 100%;
    }
    .remark_box_text {
      color: #292929;
      font-size: 0.14rem;
    }
  }
  /deep/ .el-dialog {
    border-radius: 12px;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #eeeeee;
  }
  .formpadding {
    padding-left: 11px;
    /deep/ .el-form-item__content {
      margin-left: 9px !important;
    }
  }
  /deep/ .el-form-item__content {
    margin-left: 20px !important;
  }
  /deep/ .el-form-item__label:before {
    color: #6c3dea !important;
  }
  /deep/ .el-form-item__label {
    flex-shrink: 0;
  }
  /deep/ .el-form {
    padding-left: 0rem;
  }
  .threeinline {
    display: flex;
    align-items: center;
    /deep/ .el-form-item__content {
      width: 90px;
    }
    /deep/ .el-form-item {
      margin-right: 0px;
    }
  }
  .addressdetail {
    /deep/ .el-form-item__content {
      margin-left: 120px !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (min-width: 934px) {
    .paddingContent {
      min-width: 800px;
      overflow: auto;
      .contentbox {
        display: flex;
      }
      .contentLeft {
        width: 48%;
      }
      .contentRight {
        width: 48%;
        margin-left: 4%;
      }
    }
  }
  @media screen and (max-width: 934px) {
    .paddingContent {
      min-width: 500px;
      overflow: auto;
      .contentbox {
        display: block;
      }
      .contentLeft {
        width: 100%;
      }
      .contentRight {
        width: 100%;
      }
    }
  }
}
.priceLine {
  width: 100%;
  height: 1px;
  background-color: #878399;
  position: absolute;
  bottom: 7px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/allOrder/orderDetails.vue